export default {"src":"/_next/static/media/aura-profile.fdbc8372.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};